import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useDispatch } from 'react-redux';
import './EntityState.scss';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { useAppSelector } from '../../reducers/rootReducer';
import {
  entityStatusSelectors,
  getEntityStatus,
  setEntityStatus,
} from '../../reducers/entityStatusSlice';

export default function EntityStatus(): React.ReactElement {
  const dispatch = useDispatch();

  const url = window.location.pathname;
  const entityId = url.split('/')[2];
  const entityStatus = useAppSelector(entityStatusSelectors.selectEntityStatus);

  useEffect(() => {
    if (isEmpty(entityId)) {
      return;
    }

    // Initial request
    dispatch(getEntityStatus({ entityId }));

    // Set up interval for periodic requests
    const interval = setInterval(() => {
      dispatch(getEntityStatus({ entityId }));
    }, 60000);

    // Cleanup function
    return () => {
      clearInterval(interval);
      dispatch(setEntityStatus(null));
    };
  }, [entityId, dispatch]);

  return entityStatus?.status === 'Online' ? (
    <div className="online-state">
      <RadioButtonCheckedIcon fontSize="small" />
      <span>{entityStatus.status} robot</span>
    </div>
  ) : (
    <div className="offline-state">
      <CloudOffIcon fontSize="small" />
      <span>Offline robot</span>
    </div>
  );
}
